export default __webpack_public_path__ + "static/media/OsdeBackOffice.1298483e.png";